<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert v-if="errorOccurred" color="danger" title="User Not Found">
      <span>Course record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'management-list-course'}"
                                        class="text-inherit underline">All Courses</router-link>
      </span>
    </vs-alert>

    <div v-else id="course-data">


      <!--- TOP COURSE BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div :style="`background-image: url(https://images.unsplash.com/photo-1620121692029-d088224ddc74?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2064&q=80)`"
               class="knowledge-base-jumbotron bg-cover rounded-lg vx-card">
            <div class="knowledge-base-jumbotron-content rounded-lg p-8 lg:p-12" style="backdrop-filter: blur(5px)">
              <div class="flex justify-between items-center ">
                <div>
                  <h1 class="text-white w-full" style="font-size: 4rem">{{ courseData.name }}</h1>
                </div>
                <img v-if="courseData.thumbnail" :src="courseData.thumbnail" class="rounded" width="200px">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP COURSE BANNER END --->

      <!--- COURSE ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">
          <vx-card class="bg-success-gradient p-6 cursor-pointer" @click="add_student_search_active = true">
            <div class="flex items-center justify-center">
              <feather-icon icon="UserPlusIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Assign<br>Student</h2>
            </div>
          </vx-card>
          <vx-card class="bg-warning-gradient p-6 cursor-pointer"
                   @click="$router.push(`/a/courses/${courseData.id}/subscriptions`)">
            <div class="flex items-center justify-center">
              <feather-icon icon="CreditCardIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Subscriptions<br>Manager</h2>
            </div>
          </vx-card>
          <!--- <vx-card class="bg-primary-gradient p-6 cursor-pointer" >
             <div class="flex items-center justify-center">
               <feather-icon icon="ZapIcon" svgClasses="h-16 w-16"/>
             </div>
             <div class="flex items-center justify-center">
               <h2 class="text-center mt-4">Course<br>Builder</h2>
             </div>
           </vx-card> --->
          <vx-card class="bg-danger-gradient p-6 cursor-pointer" @click="refreshCourseCache(courseData.id)">
            <div class="flex items-center justify-center">
              <feather-icon icon="RefreshCwIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4">Refresh<br>Cache</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- COURSE ACTION BAR END --->

      <!--- COURSE SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Course Id</h3>
            <h3 class="font-light">{{ courseData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Course Status</h3>
            <h3 class="capitalize font-light">{{
                courseData.status.charAt(0).toUpperCase() + courseData.status.slice(1)
              }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3 ">
          <vx-card class="p-1">
            <div class="grid grid-cols-2 gap-4 w-">
              <vs-button :to="{name: 'management-edit-course', params: { courseId: courseData.id }}"
                         class="w-full" icon="icon-edit" icon-pack="feather">Edit
              </vs-button>
              <vs-button class="w-full" color="danger" icon="icon-trash" icon-pack="feather"
                         @click="confirmDeleteCourse">Archive
              </vs-button>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- COURSE SHOW INFORMATION END--->

      <!--- COURSE SIMULATION ACTIONS START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Course Simulations</h3>
            <h3 class="capitalize font-light">{{ courseData.simulations.length }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="p-1">
            <div class="">
              <vs-button @click="add_simulation_popup = !add_remove_simulation_value"
                         class="w-full" icon="icon-plus-circle" icon-pack="feather" color="success">Add Simulation
              </vs-button>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="p-1">
            <div class="">
              <vs-button @click="remove_simulation_popup = !remove_simulation_popup"
                         class="w-full" icon="icon-x-circle" icon-pack="feather" color="danger">Remove Simulation
              </vs-button>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- COURSE SIMULATION ACTIONS END --->

      <!--- COURSE SHOW SIMULATIONS START --->
      <list-simulations :courseId="courseData.id" :filterCourse="false" :key="add_remove_simulation_key"/>
      <!--- COURSE SHOW SIMULATIONS END --->


      <vs-popup :active.sync="add_simulation_popup" class-content="AddRemoveSimCourse" title="Add Simulation To Course">
        <vs-input v-model="add_remove_simulation_value" class="mb-8 w-full" label-placeholder="Simulation ID"/>
        <vs-button @click="add_simulation_to_course()"
                   icon="icon-plus-circle" icon-pack="feather" color="success">Add Simulation
        </vs-button>
      </vs-popup>
      <vs-popup :active.sync="remove_simulation_popup" class-content="AddRemoveSimCourse" title="Remove Simulation From Course">
        <vs-input v-model="add_remove_simulation_value" class="mb-8 w-full" label-placeholder="Simulation ID"/>
        <vs-button @click="remove_simulation_from_course()"
                   icon="icon-x-circle" icon-pack="feather" color="danger">Remove Simulation
        </vs-button>
      </vs-popup>
      <vs-popup :active.sync="add_student_search_active"
                title="Search for User by Name">
        <vs-table :data="add_student_search_results" :sst="true" max-items="5" search @search="add_student_user_search">
          <template slot="header">
            <h3>Users</h3>
          </template>

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Username</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="`${attach.first_name} ${attach.last_name}`">
                {{ `${attach.first_name} ${attach.last_name}` }}
              </vs-td>

              <vs-td :data="attach.username">
                {{ attach.username }}
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" @click="add_student_to_course_options(attach)">
                  Assign
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
      <vs-popup :active.sync="add_student_assign_active" :title="`Assign ${courseData.name} To User`">
        <div class="mb-4">
          <h6>Choose Subscription Expiry</h6>
          <datepicker v-model="add_student_assign_course_calendar" :inline="true" class="datepicker-user-popup mt-4"
                      placeholder="Select Date"></datepicker>
          <ul class="flex mt-5">
            <li>
              <vs-radio v-model="add_student_assign_course_duration" class="mr-4" vs-value="1"
                        @input="calculateCalendarDate">1 Month
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="add_student_assign_course_duration" class="mr-4" vs-value="3"
                        @input="calculateCalendarDate">3 Months
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="add_student_assign_course_duration" class="mr-4" vs-value="6"
                        @input="calculateCalendarDate">6 Months
              </vs-radio>
            </li>
            <li>
              <vs-radio v-model="add_student_assign_course_duration" class="mr-4" vs-value="12"
                        @input="calculateCalendarDate">1 Year
              </vs-radio>
            </li>
          </ul>
        </div>
        <p v-if="add_student_assign_course_calendar === null" class="text-danger font-bold ">You Must Choose A
          Subscription
          Duration</p>

        <vs-button v-if="add_student_assign_course_calendar" color="primary"
                   type="filled"
                   @click="add_student_to_course_enroll(add_student_assign_user)">Assign Student
        </vs-button>

      </vs-popup>

    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline from '@/components/timeline/VxTimeline.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import ListSimulations from '../../simulations/simulation-list/ListSimulations'

export default {
  data () {
    return {

      courseData: [],
      course_modules: [],
      course_simulations: [],

      simulations_list: [],

      add_simulation_popup: false,
      add_remove_simulation_value: '',
      add_remove_simulation_key: 0,
      remove_simulation_popup: false,

      add_student_search_active: false,
      add_student_assign_active: false,
      add_student_search_results: [],
      add_student_assign_user: {},
      add_student_assign_course_duration: null,
      add_student_assign_course_calendar: null,

      course_description_counter: false,

      errorOccurred: false
    }
  },
  components: {
    StatisticsCardLine,
    VxTimeline,
    Prism,
    vSelect,
    Datepicker,
    ListSimulations
  },
  methods: {
    calculateCalendarDate () {
      const date = new Date()
      const months = parseInt(this.add_student_assign_course_duration)
      date.setMonth(date.getMonth() + months)
      this.add_student_assign_course_calendar = date
    },
    fetch_course_details (id = this.$route.params.courseId) {
      this.$http.get(`courses/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.courseData = response.data.data
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteCourse () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this course.',
        accept: this.delete_course,
        acceptText: 'Archive'
      })
    },
    delete_course () {
      this.$vs.loading()

      this.$http.delete(`courses/${this.$route.params.courseId}`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/courses')

            return this.$vs.notify({
              color: 'success',
              title: 'Course Archived',
              text: 'You have successfully archived this course',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while deleting this course.'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Delete Group',
            text: error,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    add_student_user_search (term) {
      if (!term) return
      this.$http.get(`users?search=${term}&amount=5`)
        .then(response => {
          if (response.data) {
            this.add_student_search_results = response.data.data

          }
        })
    },
    add_student_to_course_options (id) {

      this.add_student_search_active = false
      this.add_student_assign_active = true
      this.add_student_assign_user = id
      this.add_student_assign_user.profile_picture = this.add_student_assign_user.profile_picture !== null ? this.add_student_assign_user.profile_picture : 'default'


    },
    add_student_to_course_enroll (user) {

      this.$vs.loading()

      if (!this.add_student_assign_course_calendar) {
        this.$vs.notify({
          color: 'danger',
          title: 'Failed to create Subscription',
          text: 'Please provide subscription duration.',
          icon: 'feather',
          iconPack: 'icon-x-circle',
          position: 'top-right'
        })
        return this.$vs.loading.close()
      }

      const pl = {
        assigner: JSON.parse(localStorage.getItem('userInfo')).id,
        user_id: user.id,
        course_id: this.courseData.id,
        status: 'active'
      }

      pl.ending_date = this.add_student_assign_course_calendar.getTime()

      this.$http.post('subscriptions/create', pl)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Subscription Created',
              text: 'You have successfully created a subscription',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        }).catch(exception => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to create Subscription',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

      this.add_student_assign_active = false
      this.add_student_search_active = true

    },
    add_simulation_to_course () {
      this.$vs.loading()
      const data = [this.add_remove_simulation_value]
      this.$http.post(`courses/${this.courseData.id}/simulation`, data)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.fetch_course_details()
            this.add_remove_simulation_key++
            this.add_remove_simulation_value = ''
            return this.$vs.notify({
              color: 'success',
              title: 'Simulations Added',
              text: 'You have successfully added simulation to the course',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Add Simulation',
            text: 'The simulation was not added to the course',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

    },
    remove_simulation_from_course () {
      this.$vs.loading()
      const data = [this.add_remove_simulation_value]

      this.$http.delete(`courses/${this.courseData.id}/simulation`, {data})
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.add_remove_simulation_key++
            this.add_remove_simulation_value = ''
            this.fetch_course_details()
            return this.$vs.notify({
              color: 'success',
              title: 'Simulations Removed',
              text: 'You have successfully removed simulation to the course',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Remove Simulation',
            text: 'The simulation was not removed from the course',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

    },
    refreshCourseCache (id) {
      this.$vs.loading()

      this.$http.get(`courses/${id}/cache`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The course cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        })
        .catch(() => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Clear Cache',
            text: 'The course cache was not cleared successfully',
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.fetch_course_details()
  }
}

</script>

<style lang="scss">

.theme-midnight {
  .AddRemoveSimCourse {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

.theme-dark {
  .AddRemoveSimCourse {
    input.vs-inputx.vs-input--input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

#avatar-col {
  width: 10rem;
}

#page-user-view {

  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-course {
      display: none;
    }
    .course-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}

.datepicker-user-popup {
  .vdp-datepicker__calendar {
    width: 100%;
    padding: 5px 0 10px 0;
  }


  span.cell.day {
    border-radius: 5%;
    margin-bottom: 0.5%;
    margin-top: 0.5%;
  }

  span.cell.day.today {
    border-radius: 5%;
    color: #fff;
    background: rgba(var(--vs-primary), 0.1);

    &:hover {
      background: rgba(var(--vs-primary), 0.2);
    }
  }


}
</style>
